class QuantitySelector extends HTMLElement {
  private input: HTMLInputElement | null = null;
  private minusBtn: HTMLButtonElement | null = null;
  private plusBtn: HTMLButtonElement | null = null;

  constructor() {
    super();
  }

  connectedCallback() {

    this.input = this.querySelector('.quantity__input');
    this.minusBtn = this.querySelector('.quantity__button[name="minus"]');
    this.plusBtn = this.querySelector('.quantity__button[name="plus"]');

    if (!this.input || !this.minusBtn || !this.plusBtn) return;

    this.minusBtn.addEventListener('click', () => {
  
      this.updateValue(-this.getStep());
    });

    this.plusBtn.addEventListener('click', () => {
      this.updateValue(this.getStep());
    });

    this.input.addEventListener('input', () => this.validateInput());
    this.input.addEventListener('change', () => this.validateInput());
  }

  private getMin(): number {
    return parseInt(this.dataset.min || this.input?.getAttribute('min') || '1', 10);
  }

  private getMax(): number | null {
    const maxAttr = this.dataset.max || this.input?.getAttribute('max');
    return maxAttr ? parseInt(maxAttr, 10) : null;
  }

  private getStep(): number {
    return parseInt(this.dataset.step || this.input?.getAttribute('step') || '1', 10);
  }

  private updateValue(delta: number) {
    if (!this.input) return;
    let value = parseInt(this.input.value, 10) || 0;
    const min = this.getMin();
    const max = this.getMax();
    value += delta;
    if (value < min) value = min;
    if (max !== null && value > max) value = max;
    this.input.value = value.toString();
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  private validateInput() {
    if (!this.input) return;

    let value = parseInt(this.input.value, 10);
    const min = this.getMin();
    const max = this.getMax();

    if (isNaN(value) || value < min) value = min;
    if (value > max) value = max;

    this.input.value = value.toString();
  }
}

export default QuantitySelector;